export const defaultItems = [
  {
    heading: "Bundle and save: ",
    description:
      "Programs combine multiple courses into one discounted price, so you can learning more for less.",
  },
  {
    heading: "Career boost: ",
    description:
      "edX certificates can unlock new opportunities and give you access to career resources",
  },
];
